import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import injectSheet from 'react-jss';

import { getTeamFromPick } from '../../../redux/features/picks/picks';

const styles = {
  winner: {
    fontFamily: 'Roboto',
    flexGrow: '.2',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  name: {
    textTransform: 'uppercase',
    fontWeight: '400',
    fontSize: '22px',
    minWidth: '145px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  img: {
    width: '24px',
    height: '24px',
    marginRight: '10px',
  },
};

const Third = ({ classes, id }) => {
  const team = useSelector((state) => getTeamFromPick(state, id));
  return (
    <div className={classes.winner}>
      <div className={classes.container}>
        <div className={classes.win}>
          {!!team.name && (
          <div className={classes.name}>
            <img className={classes.img} src={`assets/images/flags/${team.id}.svg`} alt={team.name} />
            {team.name}
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

Third.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
};

export default injectSheet(styles)(Third);
